// extracted by mini-css-extract-plugin
module.exports = {"successful_payment":"SuccessfulPaymentCard_successful_payment__3btei"};